import { jsx } from 'panel';
import { ButtonEl } from 'common/components/button';
import { ButtonTheme } from 'common/components/button/constants';
import { InputEl } from 'common/components/input';
export function template() {
  const {
    isEditing,
    currText
  } = this.state;
  return jsx("div", {
    sel: '.text-editor'
  }, !isEditing ? jsx("div", {
    sel: '.text-wrapper',
    class: {
      'editable-text': !this.attr("disable-edit")
    },
    on: {
      click: () => this.attr("disable-edit") ? null : this.helpers.handleEditingStart()
    }
  }, jsx("slot", {
    attrs: {
      name: "content"
    }
  })) : jsx(null, null, jsx(InputEl, {
    attrs: {
      type: "textarea",
      value: currText,
      placeholder: this.attr("placeholder"),
      maxlength: this.attr("max-chars")
    },
    on: {
      input: this.helpers.handleValueChange,
      blur: this.helpers.handleSaveByBlur,
      keydown: this.helpers.handleSaveByKeyPress
    },
    props: {
      value: currText
    },
    hook: {
      insert: this.helpers.handleInputInserted
    }
  }), !this.attr("hide-footer") ? jsx("div", {
    sel: '.text-editor-footer'
  }, jsx(ButtonEl, {
    on: {
      click: this.helpers.handleCancelEdit
    }
  }, "Cancel"), jsx(ButtonEl, {
    sel: '.save-button',
    attrs: {
      theme: ButtonTheme.Primary,
      disabled: !this.helpers.textChanged()
    },
    on: {
      click: this.helpers.handleSaveByButton
    }
  }, "Save")) : null));
}